import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import { debounce } from "@/fp";

export const CopyUrl = debounce(200)((url: string, msg?: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(url);
  } else {
    const el = document.createElement("textarea");
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }
  UseToast().show({
    msg: msg || "URL copied to clipboard",
    type: ToastType.SUCCESS,
  });
});
